module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_8019.8bd29762.png";